import AuthClass from '../mw-home-auth-class';

export default class MwHomeRegistrationPageComponent extends AuthClass {

  get showLoginButton() {
    return this.configLoaded && (this.authMode !== 'dsnp_siwa' || this.authPass === true);
  }

}
